/**
 * Created by trevor on 28/09/15.
 */

function Timer(id, elem){
    this.id = id;
    this.elem = elem;

    this.duration = this.savedDuration = null;
    this.resetNow = false;

    this.direction = this.savedDirection = null;
    this.style = this.savedStyle = 1;

    this.resetTime = this.savedResetTime =  null;
    this.resetDays = this.savedResetDays = null;

    this.elapsed = 0;
    this.running = 0;
    this.lastStatus = 0;


    this.digits = [];
    this.currentDigit = 0;
    this.elem.appendChild(div('timerControls col-group',[
        div('col p33',[
            div('timerDuration', [
                this.digits[0] = text(null, null, null, {'size': 1, 'maxlength': 1}),
                span(null, ':'),
                this.digits[1] = text(null, null, null, {'size': 1, 'maxlength': 1}),
                this.digits[2] = text(null, null, null, {'size': 1, 'maxlength': 1}),
                this.caret = div('durationCaret')
            ]),
            div('timerKeys', [
                div(null, [
                    this.key7 = btn('enabled', '<span>7</span>', {
                        'click': this.keyPress.bind(this, 7)
                    }),
                    this.key8 = btn('enabled', '<span>8</span>', {
                        'click': this.keyPress.bind(this, 8)
                    }),
                    this.key9 = btn('enabled', '<span>9</span>', {
                        'click': this.keyPress.bind(this, 9)
                    })
                ]),
                div(null, [
                    this.key4 = btn('enabled', '<span>4</span>', {
                        'click': this.keyPress.bind(this, 4)
                    }),
                    this.key5 = btn('enabled', '<span>5</span>', {
                        'click': this.keyPress.bind(this, 5)
                    }),
                    this.key6 = btn('enabled', '<span>6</span>', {
                        'click': this.keyPress.bind(this, 6)
                    })
                ]),
                div(null, [
                    this.key1 = btn('enabled', '<span>1</span>', {
                        'click': this.keyPress.bind(this, 1)
                    }),
                    this.key2 = btn('enabled', '<span>2</span>', {
                        'click': this.keyPress.bind(this, 2)
                    }),
                    this.key3 = btn('enabled', '<span>3</span>', {
                        'click': this.keyPress.bind(this, 3)
                    })
                ]),
                div(null, [
                    this.key0 = btn('enabled', '<span>0</span>', {
                        'click': this.keyPress.bind(this, 0)
                    })
                ]),
                div(null, [
                    this.upButton = btn('upButton', null, {
                        'click': this.setDirection.bind(this, 1)
                    }),
                    this.dnButton = btn('dnButton', null, {
                        'click': this.setDirection.bind(this, 2)
                    })
                ])
            ])
        ]),
        div('col p33',[
            span('styleBtn', 'Style1', {'click':this.setStyle.bind(this,1)}),
            span('styleBtn', 'Style2', {'click':this.setStyle.bind(this,2)}),
            span('styleBtn', 'Style3', {'click':this.setStyle.bind(this,3)}),
            span('styleBtn', 'Style4', {'click':this.setStyle.bind(this,4)})
        ]),
        div('col timerDisplay',[
            this.timerDisplay = document.createElementNS(xmlns,'svg')
        ])
    ]));

	this.resetDaysCkBx = [];
    this.elem.appendChild(div('reset_days', [
        div(null,'<span>Reset on:</span>'),
        div(null,[
            span(null,App.WKD[0]),
            this.resetDaysCkBx[0] = chk(null, 1,
                {'click':this.checkDay.bind(this,0)})
        ]),
        div(null,[
            span(null,App.WKD[1]),
            this.resetDaysCkBx[1] = chk(null, 2,
                {'click':this.checkDay.bind(this,1)})
        ]),
        div(null,[
            span(null,App.WKD[2]),
            this.resetDaysCkBx[2] = chk(null, 4,
                {'click':this.checkDay.bind(this,2)})
        ]),
        div(null,[
            span(null,App.WKD[3]),
            this.resetDaysCkBx[3] = chk(null, 8,
                {'click':this.checkDay.bind(this,3)})
        ]),
        div(null,[
            span(null,App.WKD[4]),
            this.resetDaysCkBx[4] = chk(null, 16,
                {'click':this.checkDay.bind(this,4)})
        ]),
        div(null,[
            span(null,App.WKD[5]),
            this.resetDaysCkBx[5] = chk(null, 32,
                {'click':this.checkDay.bind(this,5)})
        ]),
        div(null,[
            span(null,App.WKD[6]),
            this.resetDaysCkBx[6] = chk(null, 64,
                {'click':this.checkDay.bind(this,6)})
        ]),
        div(null,[
            span(null,_("All")),
            this.resetDaysCkBx[7] = chk(null, 128,
                {'click':this.checkDay.bind(this,7)})
        ]),
	    this.startStopBtn = btn(null, _("Start"), {
		    'click':this.startStop.bind(this)
	    }),
        btn(null, _("Reset now"), {'click':this.resetTimer.bind(this)})
    ]));

    this.timePicker = new TimePicker('timer');
	this.timePicker.setCloseCB(this.setTime.bind(this));

    this.elem.appendChild(this.resetTimeInput = div('reset_time',[
        div(null,'<span>Reset at:</span>'),
        this.timePicker.getInputElem()
    ]));

    this.startingWindow = modalWindow(null,400,250,null,[
        p(null, _("Timer starting"))
    ]);

    this.stoppingWindow = modalWindow(null,400,250,null,[
        p(null, _("Timer stopping"))
    ]);

    this.getData();
}

Timer.prototype = {
    stateTime: function(){
        return this.lastStatus ? Date.now() - this.lastStatus : 0;
    },
	startStop: function(ev, running){
        if (this.running) this.elapsed += this.stateTime()/1000;
        this.running = typeof(running) !== 'undefined' ? running : !this.running;
        this.lastStatus = Date.now();
        this.refreshStartStopButton();
		this.pole();
	},
    resetTimer: function(ev){
        ev = ev||window.event;
        this.resetNow = true;
	    this.startStop(ev,false);
    },
    refreshStartStopButton: function(){
        this.startStopBtn.innerHTML = this.running ? _("STOP") : _("START");
    },
    checkDay: function(val){
        var i;
	    var any = 0;
        if (val === 7) {
            for (i = 0;i<7;i++){
                this.resetDaysCkBx[i].checked = this.resetDaysCkBx[7].checked;
            }
	        any = this.resetDaysCkBx[7].checked;
        } else {
            var all = 1;
            for (i = 0; i<7;i++) {
	            if (!this.resetDaysCkBx[i].checked) all = 0;
	            if (this.resetDaysCkBx[i].checked) any = 1;
            }
            this.resetDaysCkBx[7].checked = all;
        }
	    this.resetTimeInput.style.display = any ? 'block' : 'none';
	    this.resetDays = this.getResetDaysInt();
	    saveManager.queue(this);
    },
    setDirection: function(direction){
        if (this.direction !== direction){
            this.direction = direction;
            saveManager.queue(this);
        }
    },
    getData: function(){
        ajg('timer-get-data.php', ['id='+this.id],null,this.loadData,this);
    },
    loadData: function(timerData){
        // load semi permanent data
        this.duration = this.savedDuration = timerData.timer_detail.duration; // duration in mins
	    this.digits[0].value = Math.floor(this.duration / 60);
	    this.digits[1].value = Math.floor(this.duration % 60 / 10);
	    this.digits[2].value = this.duration % 10;

        this.direction = this.savedDirection = timerData.timer_detail.direction;
        this.style = this.savedStyle = timerData.timer_detail.style;

        this.resetDays = this.savedResetDays = timerData.timer_detail.reset_days;
	    this.setResetCheckBoxes();
        this.resetTime = this.savedResetTime = timerData.timer_detail.reset_time;
	    this.timePicker.setTime(this.resetTime);

        // load run data and set status
        this.lastChange = timerData.timer_detail.lastChange;
        this.elapsed = timerData.timer_detail.elapsed;
        this.running = timerData.timer_detail.running;
        this.lastStatus = Date.now() - timerData.stateTime * 1000;

        this.refreshStartStopButton();
        this.displayTimer();
        this.pole();
    },
    setResetCheckBoxes: function(){
        var all = 1, any = 0;
        for(var i = 0;i<7;i++){
            if (this.resetDays & this.resetDaysCkBx[i].value){
                this.resetDaysCkBx[i].checked = true;
	            any = 1;
            } else {
                this.resetDaysCkBx[i].checked = false;
                all = 0;
            }
        }
        this.resetDaysCkBx[7].checked = all;
	    this.resetTimeInput.style.display = any ? 'block' : 'none';
    },
    getResetDaysInt: function(){
        var i, val = 0;
        for (i = 0;i < 7;i++){
            if (this.resetDaysCkBx[i].checked) val += parseInt(this.resetDaysCkBx[i].value);
        }
        return val;
    },
    setDuration: function(){
        this.duration = (this.digits[0].value * 60) + (this.digits[1].value * 10) + (this.digits[2].value * 1);
        saveManager.queue(this);
        this.drawTimer();
    },
    setStyle: function(style){
	    this.style = style;
	    saveManager.queue(this);
    },
	setTime: function(){
		this.resetTime = this.timePicker.getTime();
		saveManager.queue(this);
	},
    mouseover: function(){},
    mousedown:function (mode, ev){
        ev = ev||window.event;
        this.dragMode = mode;
        switch (mode){
            case 1:
                this.mouseOffset = pointInElem(this.hrSlider, point(ev));
                break;
            case 2:
                this.mouseOffset = pointInElem(this.minSlider, point(ev));
                break;
            default :
        }
        startDrag(ev, this);
    },
    drag: function(ev){},
    keyPress: function(key){
        if (this.currentDigit === 1 && key > 5) return;
        // update active digit with key value
        this.digits[this.currentDigit].value = key;
        // advance cursor to next position
        this.currentDigit ++;
        if (this.currentDigit === this.digits.length) this.currentDigit = 0;
        this.hilightDigit();
        this.setDuration();
        // set available keys for position
    },
    hilightDigit: function(){
        this.caret.style.left = this.digits[this.currentDigit].offsetLeft + 'px';
	    var className = this.currentDigit === 1 ? 'disabled' : 'endabled';
	    this.key6.className = className;
	    this.key7.className = className;
	    this.key8.className = className;
	    this.key9.className = className;
    },
    saveNow: function(){
        var post = [];
        if (this.savedDuration !== this.duration) {
            this.savedDuration = this.duration;
            post.push('duration='+ this.duration);
        }
	    if (this.direction !== this.savedDirection) {
		    this.savedDirection = this.direction;
		    post.push('direction=' + this.direction);
	    }
        /*if (this.resetNow){
            post.push('resetNow=1');
            this.resetNow = false;
        }*/
        if (this.style !== this.savedStyle) {
	        this.savedStyle = this.style;
            post.push('style='+this.style);
        }
        if (this.resetDays !== this.savedResetDays) {
	        this.savedResetDays = this.resetDays;
            post.push('reset_days='+this.resetDays);
        }
	    if (this.resetTime !== this.savedResetTime) {
		    this.savedResetTime = this.resetTime;
		    post.push('reset_time=' + this.resetTime);
	    }
	    /*if (this.running != this.sRunning){
		    this.sRunning = this.running;
		    post.push('running=' + this.running);
	    }*/
        if (post.length) {
            post.push ('item_id='+this.id);
	        console.log(post);
            ajp('timer-save.php',post,null,this.saveCB,this)
        } else saveManager.nudge();
    },
    saveCB: function(reply){
        saveManager.nudge();
        if (reply.timer) {
	        this.savedDuration = reply.timer.duration;
	        this.savedDirection = reply.timer.direction;
	        this.savedStyle = reply.timer.style;
	        this.savedResetDays = reply.timer.resetDays;
	        this.savedResetTime = reply.timer.resetTime;
            this.elapsed = reply.timer.elapsed;
        }
    },
    pole: function(){
        // check status with server and look for changes

        if (this.poleAgain) clearTimeout(this.poleAgain);

        var post = [];
        post.push('id='+this.id);
        post.push('lastChange='+this.lastChange);
        post.push('elapsed='+this.elapsed);
        post.push('running='+(this.running?1:0));
        post.push('stateTime='+this.stateTime()/1000);

        if (this.resetNow) {
            post.push('resetNow=1');
            this.resetNow = false;
        }

        ajp(
            'timer-pole.php',
            post,
            null,
            this.poleCb,
            this
        );
    },
    poleCb: function(reply){
        if (reply.lastSave !== this.lastSave) {
            this.getData();
            return;
        }
        if (typeof(reply.running) !== 'undefined'){
            this.running = reply.running;
        }
        if (typeof(reply.elapsed) !== 'undefined'){
            this.elapsed = reply.elapsed;
        }
        this.refreshStartStopButton();
        this.poleAgain = setTimeout(this.pole.bind(this),5000);
    },
    displayTimer: function(){

        while (this.timerDisplay.firstChild)
            this.timerDisplay.removeChild(this.timerDisplay.firstChild);

        switch (this.style) {
            case 1:
                this.timerDisplay.appendChild(this.hrsArc = document.createElementNS(xmlns, 'path'));
                this.hrsArc.setAttribute('fill', 'none');
                this.hrsArc.setAttribute('stroke', '#99cc99');
                this.hrsArc.setAttribute('stroke-width', 20);

                this.timerDisplay.appendChild(this.minArc = document.createElementNS(xmlns, 'path'));
                this.minArc.setAttribute('fill', 'none');
                this.minArc.setAttribute('stroke', '#99cc99');
                this.minArc.setAttribute('stroke-width', 20);

                this.timerDisplay.appendChild(this.timeDisp = div());
                break;
            case 2:
                this.timerDisplay.appendChild(this.pie = document.createElementNS(xmlns, 'path'));
                this.pie.setAttribute('fill', '#99cc99');
                this.pie.setAttribute('stroke','none');
                break;
            case 3:
                this.timerDisplay.appendChild(this.hBox = document.createElementNS(xmlns, 'rect'));
                this.hBox.setAttribute('fill', '#99cc99');
                this.hBox.setAttribute('stroke', 'none');
                break;
            case 4:
                this.timerDisplay.appendChild(this.vBox = document.createElementNS(xmlns, 'rect'));
                this.vBox.setAttribute('fill', '#99cc99');
                this.vBox.setAttribute('stroke', 'none');
                break;
            default:
        }

        //this.timerDisplay.appendChild(this.testBlock = document.createElementNS(xmlns, 'rect'));
        //
        //this.testBlock.setAttributeNS(null, 'fill', '#99cc99');
        //this.testBlock.setAttributeNS(null, 'x', 150);
        //this.testBlock.setAttributeNS(null, 'y', 50);
        //this.testBlock.setAttributeNS(null, 'width', 50);
        //this.testBlock.setAttributeNS(null, 'height', 50);
        //
        //Velocity(this.testBlock, {opacity:0.2}, 500);
        //Velocity(this.testBlock, {opacity:1}, 1000);
        //Velocity(this.testBlock, {opacity:0.5}, 1000);

        //var path1 = document.createElementNS(xmlns, 'path');
        //path1.setAttributeNS(null, 'fill', 'none');
        //path1.setAttributeNS(null, 'stroke', '#99cc99');
        //path1.setAttributeNS(null, 'stroke-width', 4);
        //path1.setAttributeNS(null, 'd', 'M100 100 a80 80 0 0 1 100 100');
        //this.timerDisplay.appendChild(path1);

        //Velocity(path1,{translateX:100},400);
        this.drawTimer();

    },
    drawTimer: function (){
        // calc time remaining

        var runTime = this.running ? this.stateTime() / 1000 : 0;
        var displayTime = this.duration * 60 - this.elapsed - runTime;

        if (displayTime <= 0) this.resetTimer();

        var displayMins = displayTime/60;
        var displayHrs = Math.floor(displayMins/60);
        displayMins = displayMins % 60;

        switch (this.style) {
            case 1: // hrs and mins arcs - time in center
                var hrRadius = 60, minRadius = 40;
                var hrStart = polarToCartesian(
                    this.timerDisplay.offsetWidth/2,
                    this.timerDisplay.offsetHeight/2,
                    hrRadius, 0
                );
                var hrEnd = polarToCartesian(
                    this.timerDisplay.offsetWidth/2,
                    this.timerDisplay.offsetHeight/2,
                    hrRadius, displayHrs * 30
                );
                var minStart = polarToCartesian(
                    this.timerDisplay.offsetWidth/2,
                    this.timerDisplay.offsetHeight/2,
                    minRadius, 0
                );
                var minEnd = polarToCartesian(
                    this.timerDisplay.offsetWidth/2,
                    this.timerDisplay.offsetHeight/2,
                    minRadius, displayMins * 6
                );
                var hrLrgArc = displayHrs > 6 ? 1 : 0;
                var minLrgArc = displayMins > 30 ? 1 : 0;
                var hrDef = [
                    'M', hrStart.x, hrStart.y,
                    'A', hrRadius, hrRadius, 0, hrLrgArc, 1, hrEnd.x, hrEnd.y
                ];
                var minDef = [
                    'M', minStart.x, minStart.y,
                    'A', minRadius, minRadius, 0, minLrgArc, 1, minEnd.x, minEnd.y
                ];
                this.hrsArc.setAttribute('d', hrDef.join(' '));
                this.minArc.setAttribute('d', minDef.join(' '));
                break;
            case 2: // pie % of full time
                var radius = 80;
                var angle = 360 / (this.duration * 60000) * timeRemaining;
                var start = polarToCartesian(
                    this.timerDisplay.offsetWidth/2,
                    this.timerDisplay.offsetHeight/2,
                    radius, 0
                    );
                var end = polarToCartesian(
                    this.timerDisplay.offsetWidth/2,
                    this.timerDisplay.offsetHeight/2,
                    radius, angle
                );
                var lrgArc = angle > 180 ? 1 : 0;
                var def = [
                    'M', this.timerDisplay.offsetWidth/2, this.timerDisplay.offsetHeight/2,
                    'L', start.x, start.y,
                    'A', radius, radius, 0, lrgArc, 1, end.x, end.y,
                    'z'
                ];
                this.pie.setAttribute('d', def.join(' '));
                break;
            case 3: // rectangle of full time (horizontal)
                this.hBox.setAttribute('width', 300 / (this.duration * 60000) * timeRemaining);
                this.hBox.setAttribute('x',this.timerDisplay.offsetWidth/2 + 150 - width);
                this.hBox.setAttribute('height', 50);
                this.hBox.setAttribute('y', this.timerDisplay.offsetHeight/2 + 25);
                break;
            case 4: // rectangle of full time (vertical)
                break;
            default:
        }

        if (!displayTime && this.running) this.startStop();
        if (this.animateLoop) clearTimeout(this.animateLoop);
        this.animateLoop = setTimeout(this.drawTimer.bind(this), 1000);
    }
};